import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { ReportTypes } from "../../../reports/models/reports";
import { KpiCardsResponse } from "../../../_models/dashboard";

@Injectable({
  providedIn: "root",
})
export class OrdersKpiCardsService extends DashboardService {
  route = "order_dashboard/kpi_cards";
  protected reportType = ReportTypes.ORDER_RETENTION;
  protected data: BehaviorSubject<KpiCardsResponse> = new BehaviorSubject<KpiCardsResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }

}
